/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Feedback_ResponseInputs */

const en_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We aim to respond within 14 days and provide an accessible alternative.`)
};

const de_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bemühen uns, innerhalb von 14 Tagen zu antworten und eine zugängliche Alternative bereitzustellen.`)
};

const fr_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous nous efforcons de repondre dans les 14 jours et de fournir une alternative accessible.`)
};

const es_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro objetivo es responder en un plazo de 14 dias y proporcionar una alternativa accesible.`)
};

const it_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci impegniamo a rispondere entro 14 giorni e a fornire un'alternativa accessibile.`)
};

const nl_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wij streven ernaar om binnen 14 dagen te reageren en een toegankelijk alternatief te bieden.`)
};

const pl_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staramy sie odpowiedziec w ciagu 14 dni i zapewnic dostepna alternatywe.`)
};

const fi_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pyrimme vastaamaan 14 päivän kuluessa ja tarjoamaan saavutettavan vaihtoehdon.`)
};

const da_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi bestrasber os pa at svare inden for 14 dage og tilbyde et tilgaengeligt alternativ.`)
};

const sv_a11y_statement_feedback_response = /** @type {(inputs: A11y_Statement_Feedback_ResponseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi stravar efter att svara inom 14 dagar och erbjuda ett tillgangligt alternativ.`)
};

/**
* | output |
* | --- |
* | "We aim to respond within 14 days and provide an accessible alternative." |
*
* @param {A11y_Statement_Feedback_ResponseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_feedback_response = /** @type {((inputs?: A11y_Statement_Feedback_ResponseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Feedback_ResponseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_feedback_response(inputs)
	if (locale === "fr") return fr_a11y_statement_feedback_response(inputs)
	if (locale === "es") return es_a11y_statement_feedback_response(inputs)
	if (locale === "it") return it_a11y_statement_feedback_response(inputs)
	if (locale === "nl") return nl_a11y_statement_feedback_response(inputs)
	if (locale === "pl") return pl_a11y_statement_feedback_response(inputs)
	if (locale === "fi") return fi_a11y_statement_feedback_response(inputs)
	if (locale === "da") return da_a11y_statement_feedback_response(inputs)
	if (locale === "sv") return sv_a11y_statement_feedback_response(inputs)
	return en_a11y_statement_feedback_response(inputs)
});